import { useContext } from 'react';
import { ProfileModalContext, ProfileModalContextType } from './profile-modal-context';

export function useProfileModal(): ProfileModalContextType {
  const context = useContext(ProfileModalContext);
  if (context === undefined) {
    throw new Error('useProfileModal must be used within a ProfileModalProvider');
  }
  return context;
}